import { useEffect } from 'react';
import { SupportedLanguages } from '@/types/supportedLanguages';
import i18n from '../i18n';

const rtlLanguages = [
  SupportedLanguages.ARABIC,
  SupportedLanguages.HEBREW,
  SupportedLanguages.URDU,
  SupportedLanguages.PERSIAN,
  SupportedLanguages.PASHTO,
  SupportedLanguages.TURKISH,
  SupportedLanguages.YIDDISH,

  SupportedLanguages.ARABIC_UAE,
  SupportedLanguages.ARABIC_SAUDI_ARABIA,
  SupportedLanguages.HEBREW_ISRAEL,
  SupportedLanguages.URDU_PAKISTAN,
  SupportedLanguages.PERSIAN_IRAN,
  SupportedLanguages.PASHTO_AFGHANISTAN,
  SupportedLanguages.TURKISH_TURKEY,
];

export const useLocalization = (code: SupportedLanguages) => {
  useEffect(() => {
    i18n.changeLanguage(code);
    if (rtlLanguages.includes(code)) {
      document.body.dir = 'rtl';
    } else {
      document.body.dir = 'ltr';
    }
  }, [code]);
};
